import '../my_teams_list/index_web.css';
import './index_web.css';
import TeamBox from '../../component/team_box/index_web';

const MyTeamsListWeb = ({
  myTeamList,
  onPressPreview,
  onPressClone,
  onPressEdit,
  lineupsOut,
  title,
  matchAllPlayersList,
  contestTeams,
  gameType,
  tabType
}: any) => {
  return (
    <>
      <div className="myTeamsTab__teams__container__web">
        {myTeamList.map((item: any) => (
          <TeamBox
            selectTeamByUser={() => {}}
            joinedMatch={false}
            item={item}
            key={item.matchTeamId}
            onPressPreview={onPressPreview}
            onPressClone={onPressClone}
            onPressEdit={onPressEdit}
            onPressAlreadyJoin={() => {}}
            lineupsOut={lineupsOut}
            title={title}
            matchAllPlayersList={matchAllPlayersList}
            contestTeams={contestTeams}
            gameType={gameType}
            tabType={tabType}
          />
        ))}
      </div>
    </>
  );
};

export default MyTeamsListWeb;
